import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import {
  BibliographicResource,
  OnlineResourceGoogleBooks,
} from '®shared/bibliographic-resource';
import {
  BOOKJACKET_IMAGE_WIDTH_LARGE,
  ResourceImageUtils,
} from '®shared/container-structure';
import { GoogleBooksService } from '®shared/google-books';
import { UserPermissions } from '®shared/permissions';
import { ReadingListDetails } from '®shared/reading-list';
import { UriService } from '®shared/url-utils';

import { FetchListsForResource } from './lists-for-resource/lists-for-resource.actions';
import { selectSortedListsForResource } from './lists-for-resource/lists-for-resource.state';

@Component({
  selector: 'rl-resource-smart',
  templateUrl: './resource-smart.component.html',
})
export class ResourceSmartComponent implements OnInit {
  bibliographicResource: BibliographicResource | null;
  currentUserPermissions: UserPermissions | null;
  resourceEditUrl: string;
  resourceExportUrl: string;
  resourceImage: string;
  tenantName: string;
  listsForResource$: Observable<ReadingListDetails[]>;
  googleBookPreview$: Observable<OnlineResourceGoogleBooks>;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private uriService: UriService,
    private store: Store,
    private googleBooksService: GoogleBooksService,
  ) {
    this.bibliographicResource = this.route.snapshot.data.bibliographicResource;
    this.currentUserPermissions =
      this.route.snapshot.data.currentUser.permissions;
    this.tenantName = this.route.snapshot.data.tenant.name;
  }

  ngOnInit() {
    if (!this.bibliographicResource) {
      return;
    }
    this.titleService.setTitle(
      `${this.bibliographicResource.title} | ${this.tenantName}`,
    );

    this.resourceEditUrl = this.uriService.getResourceEditUrlForResource(
      this.bibliographicResource.id,
    );

    this.resourceExportUrl = this.uriService.getResourceExportUrl(
      this.bibliographicResource.id,
    );

    this.resourceImage = ResourceImageUtils.buildPlaceholderImageURL(
      this.bibliographicResource,
      BOOKJACKET_IMAGE_WIDTH_LARGE,
    );

    this.store.dispatch(
      new FetchListsForResource({ resourceId: this.bibliographicResource.id }),
    );

    this.listsForResource$ = this.store.select(selectSortedListsForResource);

    if (this.bibliographicResource.isbns.length > 0) {
      this.googleBookPreview$ =
        this.googleBooksService.getOnlineResourceForIsbns(
          this.bibliographicResource.isbns,
        );
    }
  }
}
